import { useTranslation } from 'react-i18next';
import { useModal } from '@/providers/modal';
import { ModalCenterLayout } from '@/kit/Modal/layouts/center';
import { MODAL_IDS } from '@/kit/Modal/keys';
import { prettyMoney } from '@scramble/utils';
import s from './index.module.scss';

const id = MODAL_IDS.lender_application_select_modal;

export const LenderApplicationSelectModal = props => {
  const { modalIds } = useModal();
  return modalIds[id] && <Modal {...props} />;
};

const Modal = ({ list = [], onSelect }) => {
  const { closeModal } = useModal();
  const { t } = useTranslation();
  const content = (
    <div className={s.modal}>
      <div className={s.header}>
        <div className="f-hero-h5">{t('modal:lender_application_select_modal.title')}</div>
        <div className="f-small-regular">
          {t('modal:lender_application_select_modal.desc')}
        </div>
      </div>
      <div className={s.content}>
        {list.map(app => {
          return (
            <div
              key={app.company.id}
              className={s.card}
              onClick={() => {
                onSelect(app);
                closeModal(id);
              }}
            >
              <div className={s.card_icon}>
                <img src={app.company.logo?.file} alt={app.company.name} width={32} height={32} />
              </div>
              <div className={s.card_content}>
                <div className={s.card_info}>
                  <div className="f-body-regular">{app.company.name}</div>
                  <div className="f-small-regular">{app.fundraising_name}</div>
                </div>
                <div className="f-body-accent">{prettyMoney(app.funds)}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );

  return (
    <ModalCenterLayout id={id} onClose={() => closeModal(id)} showClose>
      {content}
    </ModalCenterLayout>
  );
};
